<template>
    <div v-if="shownPopUpContainer" class="modal is-active" >
        <div class="modal-background"></div>
        <div class="modal-content">
           <div class="bold hm-24 hd-36 black000">{{$t('exchange-shop-details.download-pop-up.title')}}</div>
            <div class="pop-up-content-container">
                <div class="image-loader-container">
                    <image-loader src="/images/fx-download-popup.png"></image-loader>
                </div>
                <div class="left-column">
                    <div class="word-container hd-20 black000">
                        <div>{{$t('exchange-shop-details.download-pop-up.slogan-1')}}</div>
                        <div>{{$t('exchange-shop-details.download-pop-up.slogan-2')}}</div>
                    </div>
                    <div class="qr-code-container">
                        <div class="qr-code">
                            <qr-code
                                    text="https://link.hyperair.com/JR9k6MFkLV"
                                    :size="100"
                                    color="#3155A6"
                                    bg-color="#FFF"
                                    error-level="L">
                            </qr-code>
                        </div>
                        <div class="search-container">
                            <div class="search hd-18 black000 bold"><i class="far fa-search"></i>{{$t('web.download-app-banner.hyperair')}}</div>
                        </div>
                    </div>

                    <div class="app-store-container">
                        <div class="app-store"><a href="https://itunes.apple.com/hk/app/hyperair-%E5%94%B1%E9%8C%A2%E7%A5%9E%E5%99%A8-%E5%A4%96%E5%B9%A3%E9%A0%90%E8%A8%82-%E6%97%85%E9%81%8Asim%E5%8D%A1/id1397364347?mt=8" target="blank"><img src="/images/AppStore.svg"></a></div>
                        <div class="play-store"><a href="https://play.google.com/store/apps/details?id=com.hyperair.app" target="blank"><img src="/images/PlayStore.svg"></a></div>
                    </div>
                </div>
            </div>
        </div>
        <button @click="shownPopUpContainer = false" class="modal-close is-black is-large" aria-label="close"></button>
    </div>
</template>

<script>
    import { isAndroid, isIOS } from 'mobile-device-detect';
    import {redirectToAppstore} from "../helper";

    export default {
        props: {
            text: String
        },

        data(){
            return {
                shownPopUpContainer: false
            }
        },

        computed: {
        },

        methods: {

        },

        mounted() {
            this.$events.on('download-app-pop-up-container:show', ()=>{
                this.shownPopUpContainer = !this.shownPopUpContainer;
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .modal-content {
        background: #FFFFFF;
        border-radius: 8px;
        padding: 24px 32px;
        width: 768px;
        @include responsive(){
            width: 100%;
            height: 100%;
            border-radius: 0;
            max-height: unset;
            text-align: center;
            padding: 48px 32px;
        }
        .pop-up-content-container {
            display: flex;
            @include responsive(){
                flex-direction: column;
                align-items: center;
            }
            .image-loader-container {
                width: 205px;
                height: 305px;
                background: #FFFFFF;
            }
            .left-column {
                width: 100%;
                margin-top: 16px;
                margin-left: 16px;
                @include responsive(){
                    margin: unset;
                }
                .qr-code-container {
                    display: flex;
                    background: #3155A6;
                    padding: 16px;
                    margin: 16px 0;
                    .qr-code{
                        padding: 8px;
                        background: #fff0ff;
                    }

                    .search-container {
                        display: flex;
                        align-items: center;
                        margin-left: 16px;

                        .search {
                            background: #FFFFFF;
                            border: 1px solid #EEEEEE;
                            box-sizing: border-box;
                            border-radius: 4px;
                            padding: 4px 8px;

                            .far {
                                margin-right: 8px;
                            }
                        }
                    }
                }

                .app-store-container {
                    display: flex;
                    @include responsive(){
                        justify-content: center;
                    }
                    .app-store{
                        margin-right: 8px;
                    }
                }
            }

        }
    }

    .modal-close::before, .delete::before, .modal-close::after, .delete::after{
        @include responsive() {
            background-color: black;
        }
    }

</style>
